import gql from 'graphql-tag'

export default gql`
  mutation downgradeSubscriptionQuantity {
    downgradeSubscriptionQuantity {
      success
      message
    }
  }
`
